import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { gitProjectSelector } from "Reducers/project/project";
import { useAppSelector } from "Store/hooks";

import { loadingSelector, selectSubscriptionDetails } from "..";

export const useUrlParamsSubscription = () => {
  const { organizationId } = useDecodedParams<{
    organizationId: string;
  }>();
  const project = useSelectorWithUrlParams(gitProjectSelector);
  const subscription = useAppSelector(state =>
    selectSubscriptionDetails(state, {
      organizationId,
      subscriptionId: project?.getSubscriptionId()
    })
  );
  return subscription;
};

export const useIsLoadingSubscription = () => {
  return useAppSelector(loadingSelector, () => false);
};
